// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  p {
    line-height: 1.625; /* leading-relaxed */
    margin-top: 0.75rem; /* my-3 */
    margin-bottom: 0.75rem;
  }

  p:first-of-type {
    margin-top: 0; /* first:mt-0 */
  }

  p:last-of-type {
    margin-bottom: 0; /* last:mb-0 */
  }

  & > p {
    margin-top: 1.5rem; /* my-6 */
    margin-bottom: 1.5rem;
  }

  h1 {
    font-size: 1.875rem; /* text-3xl */
  }

  h2 {
    font-size: 1.5rem; /* text-2xl */
  }

  h3 {
    font-size: 1.25rem; /* text-xl */
  }

  h4 {
    font-size: 1.125rem; /* text-lg */
  }

  h5 {
    font-size: 1rem; /* text-base */
  }

  h6 {
    font-size: 0.875rem; /* text-sm */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold; /* font-bold */
    margin-top: 0; /* first:mt-0 */
    margin-bottom: 0; /* last:mb-0 */
  }

  h1,
  h2,
  h3 {
    margin-top: 0.5rem; /* mt-12 */
  }

  h4,
  h5,
  h6 {
    margin-top: 0.2rem; /* mt-8 */
  }

  a.link {
    color: #3b82f6; /* text-blue-500 */
    font-weight: 800; /* font-extrabold */
  }

  a.link:visited {
    color: #60a5fa; /* dark:text-blue-400 */
  }

  mark {
    background-color: #f87171; /* bg-red-500 */
    border-radius: 0.125rem; /* rounded-sm */
    text-decoration-skip: ink; /* decoration-clone */
    color: inherit; /* text-inherit */
    padding: 0.25rem 0; /* py-1 px-0 */
  }

  mark.dark {
    background-color: #fb7185; /* dark:bg-red-400 */
  }

  & img {
    height: auto; /* h-auto */
    width: 100%; /* w-full */
    max-width: 100%; /* max-w-full */
  }

  [data-type="horizontalRule"] {
    margin-top: 2rem; /* my-8 */
    margin-bottom: 2rem;
    padding-top: 1rem; /* py-4 */
    padding-bottom: 1rem;
    transition: all 0.1s ease-in-out; /* transition-all duration-100 ease-in-out */
    cursor: pointer;
  }

  [data-type="horizontalRule"].ProseMirror-selectednode {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
  }

  [data-type="horizontalRule"].ProseMirror-selectednode hr {
    border-top: 1px solid rgba(0, 0, 0, 0.3); /* border-t-black/30 */
  }

  [data-type="horizontalRule"]:hover:not(.ProseMirror-selectednode) {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
  }

  hr {
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */
    background-color: rgba(0, 0, 0, 0.8); /* bg-black/80 */
  }

  [data-type="emoji"] {
    display: inline-block;
  }

  [data-type="emoji"] img {
    width: 1em;
    height: 1em;
    object-fit: cover;
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/typography.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,mBAAmB,EAAE,SAAS;IAC9B,sBAAsB;EACxB;;EAEA;IACE,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,gBAAgB,EAAE,cAAc;EAClC;;EAEA;IACE,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB;EACvB;;EAEA;IACE,mBAAmB,EAAE,aAAa;EACpC;;EAEA;IACE,iBAAiB,EAAE,aAAa;EAClC;;EAEA;IACE,kBAAkB,EAAE,YAAY;EAClC;;EAEA;IACE,mBAAmB,EAAE,YAAY;EACnC;;EAEA;IACE,eAAe,EAAE,cAAc;EACjC;;EAEA;IACE,mBAAmB,EAAE,YAAY;EACnC;;EAEA;;;;;;IAME,iBAAiB,EAAE,cAAc;IACjC,aAAa,EAAE,eAAe;IAC9B,gBAAgB,EAAE,cAAc;EAClC;;EAEA;;;IAGE,kBAAkB,EAAE,UAAU;EAChC;;EAEA;;;IAGE,kBAAkB,EAAE,SAAS;EAC/B;;EAEA;IACE,cAAc,EAAE,kBAAkB;IAClC,gBAAgB,EAAE,mBAAmB;EACvC;;EAEA;IACE,cAAc,EAAE,uBAAuB;EACzC;;EAEA;IACE,yBAAyB,EAAE,eAAe;IAC1C,uBAAuB,EAAE,eAAe;IACxC,yBAAyB,EAAE,qBAAqB;IAChD,cAAc,EAAE,iBAAiB;IACjC,kBAAkB,EAAE,cAAc;EACpC;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;EACjD;;EAEA;IACE,YAAY,EAAE,WAAW;IACzB,WAAW,EAAE,WAAW;IACxB,eAAe,EAAE,eAAe;EAClC;;EAEA;IACE,gBAAgB,EAAE,SAAS;IAC3B,mBAAmB;IACnB,iBAAiB,EAAE,SAAS;IAC5B,oBAAoB;IACpB,gCAAgC,EAAE,4CAA4C;IAC9E,eAAe;EACjB;;EAEA;IACE,qCAAqC,EAAE,eAAe;EACxD;;EAEA;IACE,wCAAwC,EAAE,sBAAsB;EAClE;;EAEA;IACE,qCAAqC,EAAE,eAAe;EACxD;;EAEA;IACE,SAAS;IACT,wCAAwC,EAAE,6BAA6B;IACvE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;AACF","sourcesContent":[".ProseMirror {\n  p {\n    line-height: 1.625; /* leading-relaxed */\n    margin-top: 0.75rem; /* my-3 */\n    margin-bottom: 0.75rem;\n  }\n\n  p:first-of-type {\n    margin-top: 0; /* first:mt-0 */\n  }\n\n  p:last-of-type {\n    margin-bottom: 0; /* last:mb-0 */\n  }\n\n  & > p {\n    margin-top: 1.5rem; /* my-6 */\n    margin-bottom: 1.5rem;\n  }\n\n  h1 {\n    font-size: 1.875rem; /* text-3xl */\n  }\n\n  h2 {\n    font-size: 1.5rem; /* text-2xl */\n  }\n\n  h3 {\n    font-size: 1.25rem; /* text-xl */\n  }\n\n  h4 {\n    font-size: 1.125rem; /* text-lg */\n  }\n\n  h5 {\n    font-size: 1rem; /* text-base */\n  }\n\n  h6 {\n    font-size: 0.875rem; /* text-sm */\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: bold; /* font-bold */\n    margin-top: 0; /* first:mt-0 */\n    margin-bottom: 0; /* last:mb-0 */\n  }\n\n  h1,\n  h2,\n  h3 {\n    margin-top: 0.5rem; /* mt-12 */\n  }\n\n  h4,\n  h5,\n  h6 {\n    margin-top: 0.2rem; /* mt-8 */\n  }\n\n  a.link {\n    color: #3b82f6; /* text-blue-500 */\n    font-weight: 800; /* font-extrabold */\n  }\n\n  a.link:visited {\n    color: #60a5fa; /* dark:text-blue-400 */\n  }\n\n  mark {\n    background-color: #f87171; /* bg-red-500 */\n    border-radius: 0.125rem; /* rounded-sm */\n    text-decoration-skip: ink; /* decoration-clone */\n    color: inherit; /* text-inherit */\n    padding: 0.25rem 0; /* py-1 px-0 */\n  }\n\n  mark.dark {\n    background-color: #fb7185; /* dark:bg-red-400 */\n  }\n\n  & img {\n    height: auto; /* h-auto */\n    width: 100%; /* w-full */\n    max-width: 100%; /* max-w-full */\n  }\n\n  [data-type=\"horizontalRule\"] {\n    margin-top: 2rem; /* my-8 */\n    margin-bottom: 2rem;\n    padding-top: 1rem; /* py-4 */\n    padding-bottom: 1rem;\n    transition: all 0.1s ease-in-out; /* transition-all duration-100 ease-in-out */\n    cursor: pointer;\n  }\n\n  [data-type=\"horizontalRule\"].ProseMirror-selectednode {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n  }\n\n  [data-type=\"horizontalRule\"].ProseMirror-selectednode hr {\n    border-top: 1px solid rgba(0, 0, 0, 0.3); /* border-t-black/30 */\n  }\n\n  [data-type=\"horizontalRule\"]:hover:not(.ProseMirror-selectednode) {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */\n    background-color: rgba(0, 0, 0, 0.8); /* bg-black/80 */\n  }\n\n  [data-type=\"emoji\"] {\n    display: inline-block;\n  }\n\n  [data-type=\"emoji\"] img {\n    width: 1em;\n    height: 1em;\n    object-fit: cover;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
